import {
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import { debounceTime, Subject, Subscription } from 'rxjs';
import { ChannelsService } from 'src/app/core/services/channels.service';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ChannelsDialogComponent } from 'src/app/features/secured-skeleton/channels/channels-dialog/channels-dialog.component';
import { ConfigDataService } from 'src/app/core/services/config-data.service';
import { SubscriptionModel } from 'src/app/core/interfaces/subscription.interface';

@Component({
    selector: 'app-channels-header',
    templateUrl: './channels-header.component.html',
    styleUrls: ['./channels-header.component.scss'],
    standalone: false
})
export class ChannelsHeaderComponent implements OnInit, OnDestroy {
  constructor(
    private channelService: ChannelsService,
    private _snackBar: MatSnackBar,
    public dialog: MatDialog,
    private configDataService: ConfigDataService
  ) {
    this.getChannelsSubs = channelService
      .getChannelsSubs()
      .subscribe((info: SubscriptionModel) => {
        if (
          info.channel === 'ChannelsTableComponent - ChannelsHeaderComponent' &&
          info.broadcastID === 'ChannelsTableComponent'
        ) {
          if (info.payload.enableAddButton) {
            this.disableAddButton = false;
          }
          if (info.payload.clearSearch) {
            this.searchValue = '';
            this.searchOpen = false;
          }
        }
      });
  }

  @ViewChild('userSearch') userSearch: ElementRef;
  @Input() assignMode: boolean = false;

  private getChannelsSubs: Subscription;

  searchOpen: boolean = false;
  searchValue: string = '';
  debouncer: Subject<string> = new Subject();
  disableAddButton: boolean = true;

  ngOnInit(): void {
    this.debouncer.pipe(debounceTime(300)).subscribe((valor) => {
      this.searchUser(valor);
    });
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 6000
    });
  }

  openCreateChannelsDialog() {
    const logoLibrary = this.configDataService.logoLibrary;
    const defaultLogo = logoLibrary.find((logo) => logo.is_default === true);
    const dialogRef = this.dialog.open(ChannelsDialogComponent, {
      panelClass: 'app-channels-panel-class',
      data: {
        code: 'add-channel',
        channel: {
          name: '',
          logo_id: defaultLogo.id,
          stream_source: '',
          provider: ''
        },
        logosLibrary: logoLibrary
      }
    });

    dialogRef.afterClosed().subscribe((result: string) => {
      if (result === 'channel-saved') {
        this.channelService.sendChannelSubs({
          channel: 'ChannelsHeaderComponent - ChannelsTableComponent',
          broadcastID: 'ChannelsHeaderComponent',
          payload: {
            refresh: true
          }
        });
        this.openSnackBar('Station saved successfully', 'Ok');
      }
    });
  }

  onFocusOutEvent(event) {
    if (event.target.value == '') {
      this.clickEvent();
    }
  }

  clickEvent() {
    this.searchOpen = !this.searchOpen;

    if (this.searchOpen) {
      setTimeout(() => {
        this.userSearch.nativeElement.focus();
      }, 300);
    }
  }

  keyPressed(event: any) {
    this.debouncer.next(event.target.value);
  }

  searchUser(searchValue: string) {
    this.channelService.sendChannelSubs({
      channel: 'ChannelsHeaderComponent - ChannelsTableComponent',
      broadcastID: 'ChannelsHeaderComponent',
      payload: {
        searchValue
      }
    });
  }

  ngOnDestroy(): void {
    this.getChannelsSubs?.unsubscribe();
  }
}
